// frontend/src/hooks/useCostReconciliation.ts
import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface ReconciliationRow {
  day: string; // ISO date (UTC)
  model: string;
  estimated_usd: number;
  billed_usd: number;
  delta_usd: number;
  drift_pct: number | null;
  alarm: boolean;
}

export interface ReconciliationSummary {
  estimated_usd: number;
  billed_usd: number;
  drift_pct: number | null;
  drift_alarm: boolean;
  worst_day: string | null;
  worst_model: string | null;
  worst_delta_usd: number | null;
  unmatched_billed_models: string[];
  unmatched_estimated_models: string[];
  excluded_billed_usd: number;
}

export interface CostReconciliationResponse {
  configured: boolean;
  error: string | null;
  fetched_at: string | null;
  window_days: number | null;
  rows: ReconciliationRow[];
  summary: ReconciliationSummary | null;
}

export function useCostReconciliation() {
  return useQuery<CostReconciliationResponse>({
    queryKey: ["admin", "costs", "reconciliation"],
    queryFn: () =>
      apiClient
        .get("api/admin/costs/reconciliation")
        .json<CostReconciliationResponse>(),
    staleTime: 5 * 60_000, // server caches for 1h; this just dedupes tab flips
    retry: false,
    refetchOnWindowFocus: false,
  });
}
